<template>
  <div>
      <h2>This is a dummy Vue component</h2>
      <p>If you see this component, Vue is working correctly</p>
  </div>
</template>

<script lang="ts">
import Vue from 'vue';
import { Component } from 'vue-property-decorator';

@Component
export default class Dummy extends Vue {
}

</script>
